import React from "react";
import { MainDiv } from "../components/Profile/Profile.style";
import UserTable from "../components/setup/userSetup/UserTable";
import { VolunteerHeading } from "../components/Volunteer/Volunteer.style";

function UserSetup() {
  return (
    <MainDiv>
      <VolunteerHeading>User Setup</VolunteerHeading>
      <UserTable />
    </MainDiv>
  );
}

export default UserSetup;
